/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Heading as ChromaHeading } from '@iag-packages/chroma-react/lib/components';

export const Heading = ({ ...props }) => <ChromaHeading {...props} />;

export default Heading;
